import { Injectable } from '@angular/core';
import {
  CanLoad,
  CanActivate,
  Router,
  Route,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import {Constant} from '../constants/constant.class';

@Injectable()
export class AuthGuard implements CanLoad, CanActivate {
  constructor(private router: Router) {}

  canLoad(route: Route): boolean {
    if (this.isLoggedIn()) {
      return true;
    }
    //this.router.navigate(['/login']);
    this.router.navigate([Constant.LOGIN]);
    return false;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // check authentication
    return this.isLoggedIn(state.url);
  }

  isLoggedIn(url?: string): boolean {
    const currentUser = localStorage.getItem(Constant.TOKEN);
    if (currentUser && currentUser !== Constant.TOKEN) {
      return true;
    }
    // not logged in so redirect to login page with the return url
    if (url.includes('admin'))
      this.router.navigate(['/admin-login'], { queryParams: { returnUrl: url }});
    else if (url.includes('csc'))
      this.router.navigate(['/csc-login'], { queryParams: { returnUrl: url }});
    else {
      this.router.navigate([Constant.LOGIN], {queryParams: {returnUrl: url}});
    }
    return false;
  }
}
